<!DOCTYPE html>
<html>
<head>
    <title>Política de cookies Jeanologia Market Place</title>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
</head>
<body>
<div class="container">
    <div class="row">
        <div class="col" >
            <div class="w-100 d-flex flex-row justify-content-center align-items-center" style="margin-top: 50px !important;">
                <h2 class="title">
                    {{ 'cookie-policy.title' | translate }}
                </h2>
            </div>
            <div class="updateDate">
                {{ 'cookie-policy.update-date' | translate }}
            </div>
            <h3 class="heading">
                {{ 'cookie-policy.heading-1' | translate }}
            </h3>
            <div class="description">
                {{ 'cookie-policy.description-1' | translate }}
            </div>
            <h3 class="heading">
                {{ 'cookie-policy.heading-2' | translate }}
            </h3>
            <div class="description">
                <ul>
                    <li [innerHTML]="'cookie-policy.description-2-i' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-2-ii' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-2-iii' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-2-iv' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-2-v' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-2-vi' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-2-vii' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-2-viii' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-2-ix' | translate"></li>
                </ul>
            </div>
            <h3 class="heading">
                {{ 'cookie-policy.heading-3' | translate }}
            </h3>
            <div class="description">
                {{ 'cookie-policy.description-3' | translate }}
                <ul>
                    <li [innerHTML]="'cookie-policy.description-3-i' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-3-ii' | translate"></li>
                </ul>
                {{ 'cookie-policy.description-3-p1' | translate }}
                <ul>
                    <li [innerHTML]="'cookie-policy.description-3-iii' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-3-iv' | translate"></li>
                </ul>
                {{ 'cookie-policy.description-3-p2' | translate }}
                <ul>
                    <li [innerHTML]="'cookie-policy.description-3-v' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-3-vi' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-3-vii' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-3-viii' | translate"></li>
                    <li [innerHTML]="'cookie-policy.description-3-ix' | translate"></li>
                </ul>
            </div>
            <h3 class="heading">
                {{ 'cookie-policy.heading-4' | translate }}
            </h3>
            <h4>{{ 'cookie-policy.heading-5' | translate }}</h4>
            <div class="description">
                {{ 'cookie-policy.description-5' | translate }}
            </div>
            <table>
                <tr>
                    <th>{{ 'cookie-policy.table-th-1' | translate }}</th>
                    <th>{{ 'cookie-policy.table-th-2' | translate }}</th>
                    <th>{{ 'cookie-policy.table-th-3' | translate }}</th>
                    <th>{{ 'cookie-policy.table-th-4' | translate }}</th>
                </tr>
                <tr class="trBorderBottom">
                    <td>{{ 'cookie-policy.table-td-1' | translate }}</td>
                    <td>{{ 'cookie-policy.table-td-2' | translate }}</td>
                    <td>{{ 'cookie-policy.table-td-3' | translate }}</td>
                    <td>{{ 'cookie-policy.table-td-4' | translate }}</td>
                </tr>
                <tr>
                    <td>{{ 'cookie-policy.table-td-5' | translate }}</td>
                    <td>{{ 'cookie-policy.table-td-6' | translate }}</td>
                    <td>{{ 'cookie-policy.table-td-7' | translate }}</td>
                    <td>{{ 'cookie-policy.table-td-8' | translate }}</td>
                </tr>
            </table>
            <h4>{{ 'cookie-policy.heading-6' | translate }}</h4>
            <div class="description">
                {{ 'cookie-policy.description-5' | translate }}
            </div>
            <h4>{{ 'cookie-policy.heading-7' | translate }}</h4>
            <div class="description">
                {{ 'cookie-policy.description-6' | translate }}
            </div>
            <h4>{{ 'cookie-policy.heading-8' | translate }}</h4>
            <div class="description">
                {{ 'cookie-policy.description-7' | translate }}
            </div>
            <h5 class="heading">
                {{ 'cookie-policy.heading-9' | translate }}
            </h5>
            <div class="description">
                {{ 'cookie-policy.description-8' | translate }}

                <p>
                    <strong><a href="http://support.google.com/chrome/answer/95647?hl=es">{{ 'cookie-policy.chrome' | translate }}</a></strong><br/>
                    <strong><a href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">{{ 'cookie-policy.firefox' | translate }}</a></strong><br/>
                    <strong><a href="http://windows.microsoft.com/es-es/windows-vista/block-or-allow-cookies">{{ 'cookie-policy.explorer' | translate }}</a></strong><br/>
                    <strong><a href="http://support.apple.com/es-es/HT1677">{{ 'cookie-policy.safari' | translate }}</a></strong><br/>
                    <strong><a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DAndroid&hl=es">{{ 'cookie-policy.chrome2' | translate }}</a></strong><br/>
                </p>

                <p [innerHTML]="'cookie-policy.info' | translate"></p>
            </div>

            <div class="footer">
                {{ 'cookie-policy.footer' | translate }}
            </div>
        </div>
    </div>
</div>
</body>

</html>
